import { HUMAN_SUPPORT_STATUS } from "store/apis/chatHumanSupport";
import { useChannelStateContext } from "stream-chat-react";

type EscalationStatus =
  | (typeof HUMAN_SUPPORT_STATUS)[keyof typeof HUMAN_SUPPORT_STATUS]
  | null;

type ChannelEscalationStatus = {
  channelId: string;
  escalationStatus: EscalationStatus;
};

export const useChannelEscalationStatus = (): ChannelEscalationStatus => {
  const { channel } = useChannelStateContext();
  const channelId = channel.id || "";
  const escalationStatus =
    (channel?.data as { escalation_status?: EscalationStatus } | undefined)
      ?.escalation_status ?? null;

  return { channelId, escalationStatus };
};
